/* eslint-disable no-unused-vars */
import {
  CheckboxGroup,
  LabeledInput,
  Panel,
  RadioGroup,
  Text,
  TextArea,
} from '@epam/promo';
import {
  Task,
  VALIDATION_TYPE,
  ValidationType,
  WORK_MODEL,
  WorkModel,
} from 'models/task.model';
import css from './FormBody.module.scss';
import { useTaskStore } from 'store/task.store';
import { useLocation } from 'react-router-dom';

export const FormBody = ({ task }: { task: Task }) => {
  const location = useLocation();
  const errors = useTaskStore((state) => state.errors);
  const {
    setDraftTitle,
    setDraftDescription,
    setDraftWorkModels,
    setDraftValidator,
    setDraftAnswer,
    setDraftErrorMessage,
  } = useTaskStore((state) => state.actions);

  return (
    <Panel
      cx={
        task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          ? `${css.form} ${css.form__disabled}`
          : css.form
      }>
      <LabeledInput
        isRequired
        cx={css.form__label}
        label="Title"
        labelPosition="left">
        <TextArea
          autoSize
          isRequired
          autoFocus={location.pathname === '/tasks/create'}
          inputCx={`${css.textarea__input} ${
            task.title.length > 0 &&
            errors.title &&
            css['textarea__input--error']
          }`}
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          isInvalid={!!errors.title}
          placeholder="Add title"
          size="48"
          value={task.title}
          onValueChange={setDraftTitle}
        />
        <Text cx={css['form__error-message']}>
          {task.title.length > 0 ? errors.title : ''}
        </Text>
      </LabeledInput>
      <LabeledInput
        isRequired
        cx={css.form__label}
        label="Description"
        labelPosition="left">
        <TextArea
          autoSize
          inputCx={`${css.textarea__input} ${
            task.description.length > 0 &&
            errors.description &&
            css['textarea__input--error']
          }`}
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          isInvalid={!!errors.description}
          placeholder="Add description"
          size="48"
          value={task.description}
          onValueChange={setDraftDescription}
        />
        <Text cx={css['form__error-message']}>
          {task.description.length > 0 ? errors.description : ''}
        </Text>
      </LabeledInput>
      <LabeledInput
        isRequired
        cx={`${css.form__label} ${css.form__label__gutter}`}
        label="Type"
        labelPosition="left">
        <CheckboxGroup
          cx={css.radio__container}
          direction="vertical"
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          isInvalid={!!errors.workModels}
          items={Object.keys(WORK_MODEL).map((model) => ({
            id: model,
            name: WORK_MODEL[model as WorkModel],
          }))}
          value={task.workModels as WorkModel[]}
          onValueChange={setDraftWorkModels}
        />
        <Text cx={css['form__error-message']}>{errors.workModels}</Text>
      </LabeledInput>
      <LabeledInput
        isRequired
        cx={`${css.form__label} ${css.form__label__gutter}`}
        label="Validator"
        labelPosition="left">
        <RadioGroup
          cx={css.radio__container}
          direction="vertical"
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          isInvalid={!!errors.validator}
          items={Object.keys(VALIDATION_TYPE)
            .filter((validation) => validation !== 'NULL')
            .map((validation) => ({
              id: validation,
              name: VALIDATION_TYPE[validation as ValidationType],
            }))}
          value={task.validator as ValidationType}
          onValueChange={setDraftValidator}
        />
        {task.validator === 'CONTAINS' && (
          <>
            <TextArea
              autoSize
              autoFocus={
                task.status === 'NOT_SAVED' && task.validator === 'CONTAINS'
              }
              cx={`${css.textarea__input__gutter} ${
                task.answer.length > 0 &&
                errors.answer &&
                css['textarea__input--error']
              }`}
              inputCx={css.textarea__input}
              isDisabled={
                task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
              }
              isInvalid={!!errors.answer}
              placeholder="Add answer"
              size="48"
              value={task.answer}
              onValueChange={setDraftAnswer}
            />
            <Text
              cx={`${css['form__error-message']} ${css['form__error-message__gutter']}`}>
              {errors.answer}
            </Text>
          </>
        )}
      </LabeledInput>
      <LabeledInput
        isOptional
        cx={css.form__label}
        label="Error message"
        labelPosition="left">
        <TextArea
          autoSize
          inputCx={`${css.textarea__input} ${
            task.errorMessage.length > 0 &&
            errors.errorMessage &&
            css['textarea__input--error']
          }`}
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          isInvalid={!!errors.errorMessage}
          placeholder={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
              ? 'No error message'
              : 'Add error message'
          }
          size="48"
          value={task.errorMessage}
          onValueChange={setDraftErrorMessage}
        />
        <Text cx={css['form__error-message']}>{errors.errorMessage}</Text>
      </LabeledInput>
      <LabeledInput
        isOptional
        cx={css.form__label}
        label="Comment"
        labelPosition="left">
        <TextArea
          autoSize
          inputCx={css.textarea__input}
          isDisabled={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
          }
          placeholder={
            task.status === 'PENDING_APPROVAL' || task.status === 'APPROVED'
              ? 'No comment'
              : 'Add comment'
          }
          size="48"
          value=""
          onValueChange={() => {}}
        />
      </LabeledInput>
    </Panel>
  );
};
